<template>
  <div>
    <div class="item">
      <label class="lft">工程名称：</label>
      <label class="cnt"
        ><div v-for="item in task">{{ item.enginner_name }}</div></label
      >
    </div>
    <div class="item">
      <label class="lft">所在地区：</label>
      <label class="cnt">
        <div v-for="item in task">
          {{ item.province }}{{ item.city }}{{ item.area }}
        </div></label
      >
    </div>
    <div class="item">
      <label class="lft">详细地址：</label>
      <label class="cnt">
        <div v-for="item in task">{{ task.address }}</div></label
      >
    </div>
    <div class="item">
      <label class="lft">分配车辆：</label>
      <div class="cnt">
        <el-tag
          style="margin-right: 10px"
          v-if="data.car.id > 0"
          closable
          type="primary"
          @close="onCarDel()"
          >{{ data.car.carno }}</el-tag
        >
        <el-button size="small" @click="selectCar()">选择</el-button>
      </div>
    </div>
    <div class="item">
      <label class="lft">分配司机：</label>
      <div class="cnt">
        <el-tag
          style="margin-right: 10px"
          v-if="data.driver.id > 0"
          closable
          type="danger"
          @close="onDriverDel()"
          >{{ data.driver.name }}</el-tag
        >
        <el-button size="small" @click="selectDriver()">选择</el-button>
      </div>
    </div>
    <div style="margin-top: 20px">
      <el-button type="primary" style="width: 100%" @click="submitForm()"
        >确定分配</el-button
      >
    </div>
    <el-dialog
      title="选择车辆"
      :append-to-body="true"
      :visible.sync="dialogSelectCar"
      width="80%"
    >
      <SelCar ref="selCar" @carSelected="onCarSelected"></SelCar>
    </el-dialog>
    <el-dialog
      title="选择司机"
      :append-to-body="true"
      :visible.sync="dialogSelectDriver"
      width="80%"
    >
      <SelStaff ref="selGroup" @staffSelected="onDriverSelected"></SelStaff>
    </el-dialog>
  </div>
</template>
<script>
import SelStaff from "@/views/dialog/sel_staff.vue";
import SelCar from "@/views/dialog/sel_car.vue";
export default {
  name: "task_setcar",
  components: { SelStaff, SelCar },
  data() {
    return {
      taskids: "",
      dialogSelectCar: false,
      dialogSelectDriver: false,
      task: [],
      data: { subtaskid: 0, car: {}, driver: {} },
    };
  },
  methods: {
    async showInfo(id) {
      this.taskids = id;
      this.task = await this.$api.request.get("/task/getlist", {
        params: {
          id: id,
        },
      });
      var oneid = id;
      oneid = oneid.split(",")[0];
      this.data = await this.$api.request.get("/task/get_cardriver", {
        params: {
          taskid: oneid,
        },
      });
    },
    async submitForm() {
      if (this.data.car.id == 0) {
        this.$api.error("请选择车辆");
        return;
      }
      if (this.data.driver.id == 0) {
        this.$api.error("请选择司机");
        return;
      }

      await this.$api.confirm("确认继续吗？");
      var data = await this.$api.request.post("/task/save_cardriver", {
        //subtaskid: this.data.subtaskid,
        taskids: this.taskids,
        carid: this.data.car.id,
        driverid: this.data.driver.id,
      });
      this.$api.success("派车成功");
      this.$router.replace("/");
      this.$emit("onSuccess", { id: this.data.id });
    },
    selectCar() {
      this.dialogSelectCar = true;
      this.$nextTick(() => {
        this.$refs.selCar.showInfo(1);
      });
    },
    onCarSelected(list) {
      this.dialogSelectCar = false;
      this.data.car.id = list[0].id;
      this.data.car.carno = list[0].carno;
    },
    selectDriver() {
      this.dialogSelectDriver = true;
      this.$nextTick(() => {
        this.$refs.selGroup.showInfo("siji", 1, this.data.subtaskid);
      });
    },
    onDriverSelected(list) {
      this.dialogSelectDriver = false;
      this.data.driver.id = list[0].id;
      this.data.driver.name = list[0].name;
    },
    onCarDel() {
      this.data.car = { id: 0, carno: "" };
    },
    onDriverDel(id) {
      this.data.driver = { id: 0, name: "" };
    },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  align-items: center;
  min-height: 40px;
}
.item .lft {
  text-align: left;
  min-width: 80px;
}
.item .cnt {
  text-align: left;
}
</style>
